export const messageData = [
    'Find California',
	'Find American',
	'Find Summer',
	'Find Billy',
	'Find girlfriend',
    'Find crib',
    'Artist Eagles',
    'Artist Taylor Swift',
    'Artist Eminem'
];

export const messageDataFont = [
    '12',
	'14',
	'18',
	'24',
    '30'
];

export const RendomLineData = [
    'Line 1:4',
	'Line 5:2',
	'Line 2:3',
	'Line 9:5',
	'Line 18:42',
    'Line 29:1',
    'Line 30:3',
    'Line 103:1',
    'Line 10:2'
];

export const langMap = [
    { code: "ar", lang: "Arabic" },
    { code: "zh", lang: "Chinese, Mandarin" },
    { code: "da", lang: "Danish" },
    { code: "nl", lang: "Dutch" },
    { code: "en", lang: "English, Australian" },
    { code: "en", lang: "English, British" },
    { code: "en", lang: "English, Indian" },
    { code: "en", lang: "English, US" },
    { code: "en", lang: "English, Welsh" },
    { code: "fr", lang: "French" },
    { code: "fr", lang: "French, Canadian" },
    { code: "hi", lang: "Hindi" },
    { code: 'he', lang: 'Hebrew' },
    { code: "de", lang: "German" },
    { code: "is", lang: "Icelandic" },
    { code: "it", lang: "Italian" },
    { code: "ja", lang: "Japanese" },
    { code: "ko", lang: "Korean" },
    { code: "no", lang: "Norwegian" },
    { code: "pl", lang: "Polish" },
    { code: "pt", lang: "Portuguese" },
    { code: "pt", lang: "Portuguese, Brazilian" },
    { code: "ro", lang: "Romanian" },
    { code: "ru", lang: "Russian" },
    { code: "es", lang: "Spanish, Castilian" },
    { code: "es", lang: "Spanish, Mexican" },
    { code: "es", lang: "Spanish, US" },
    { code: "sv", lang: "Swedish" },
    { code: "tr", lang: "Turkish" },
    { code: "cy", lang: "Welsh" }
  
  ];

  export const valueLabels = [
    'Unranked',
    'Lowest',
    'Signifcantly Below Average',
    'Clearly Below Average',
    'Below Average',
    'Average',
    'Above Average',
    'Clearly Above Average',
    'Signifcantly Above Average',
    'Near Highest',
    'Highest'
];

export const marks = [
    { value: 0, label: '0' },
    { value: 10 },
    { value: 20 },
    { value: 30 },
    { value: 40 },
    { value: 50 },
    { value: 60 },
    { value: 70 },
    { value: 80 },
    { value: 90 },
    { value: 100, label: '10' },
];